import filesize from 'file-size'

export default {
  methods: {
    getFilesize (fileSize) {
      return filesize(fileSize, {
        fixed: 2,
        spacer: ''
      }).human('jedec')
    },
    getIcon (icon = '') {
      switch (icon.toLowerCase()) {
        case 'pdf':
          return 'mdi-file-pdf-box'
        case 'png':
        case 'jpeg':
        case 'jpg':
        case 'gif':
          return 'mdi-file-image'
        case 'zip':
        case 'rar':
          return 'mdi-zip-box'
        default:
          return 'mdi-file'
      }
    },
    getNextAvailableImage (file) {
      if (file.type !== 'IMAGE') {
        return null
      }

      // Attempt to pull cached version from VueX.
      // If exists, override the existing signed_thumbnail_url with this,
      //  as the file must've been modified
      const cachedImg = this.$store.getters['files/thumbnail'](file.id)
      if (cachedImg) {
        file.signed_thumbnail_url = cachedImg
      }

      // Return the signed img normally
      return file.signed_thumbnail_url
    },
    getFullSizeImage (file) {
      if (file.type !== 'IMAGE') {
        return null
      }
      return file.signed_url
    },
    getVisiblityOptions (user = null) {
      const name = user ? user.name : 'The uploader'
      return [
        { label: 'Everyone can search for this file', value: 'EVERYONE' },
        { label: `${name} and admins can search for this file`, value: 'MYSELF' }
      ]
    },
    baseDeleteFile (file, successCallback = () => {}) {
      this.$q.dialog({
        title: 'Confirm',
        message: [
          'Are you sure you want to delete this file?',
          {
            labelClass: 'text-bold text-red-7',
            message: !!file.attachments_count && `This file is attached to ${file.attachments_count} item(s). The attachments will be removed if this file is deleted.`
          }
        ],
        banner: 'This action cannot be undone',
        ok: true,
        cancel: true,
        color: 'orange-7'
      })
        .onOk(async () => {
          this.$loading.show()
          const { status } = await this.$remove('v1/files', {
            id: file.id
          })
          this.$loading.hide()
          if (status === 'success') {
            this.$q.notify({
              color: 'orange',
              textColor: 'black',
              message: 'File successfully deleted.'
            })
            successCallback()
          }
        })
    },
    async baseToggleVisibility (file, successCallback = () => {}) {
      this.$loading.show()
      const { status, payload } = await this.$post('v1/files/toggleVisibility', {
        id: file.id
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$q.notify({
          color: 'green',
          message: 'File visibility successfully toggled'
        })
        successCallback(payload.visibility)
      }
    },
    async baseDownloadFile (file, successCallback = () => {}) {
      this.$loading.show()
      const { status, payload } = await this.$get('v1/files/download', {
        id: file.id
      })
      this.$loading.hide()
      if (status === 'success') {
        successCallback(payload.signed_url)
      }
    }
  }
}
